module.exports = __webpack_public_path__ + "img/1473948580.4befe62a.jpg";